<template lang="pug">
  .column.middle.center.m-top-6
    img.m-bottom-4(:src='inProgressImage' width='350px')
    h2.title-medium.dark-gray.m-bottom-1 {{ $t("inProgress.pageInProgress") }}
    h3.text-normal.dark-gray {{ description }}
</template>

<script>
import inProgressImage from '@/assets/ic_noresults.svg'

export default {
  props: {
    description: { type: String }
  },
  data() {
    return {
      inProgressImage
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
